import { Box } from "@chakra-ui/react";
import React from "react";
import { useSelector } from "react-redux";
import { userDetailsTab } from "../../../constants";
import BusinessDetails from "./BusinessDetails";
import DirectorInformation from "./DirectorInformation";
import LoanDetails from "./LoanDetails";
import PersonalInformation from "./PersonalInformation";

const UserInformation = () => {
  const { currentTimelineStep } = useSelector((store) => store.userDetails);
  return (
    <Box flex="1" display="flex" ml={"10px"} mt={2} flexDirection="column">
      {/* Render the current tab's component */}
      {userDetailsTab.map((tabName, index) => {
        if (currentTimelineStep !== index + 1) return null;

        switch (tabName) {
          case "Personal Information":
            return <PersonalInformation key={tabName} />;
          case "Loan Details":
            return <LoanDetails key={tabName} />;
          case "Business Details":
            return <BusinessDetails key={tabName} />;
          case "Director Information":
            return <DirectorInformation key={tabName} />;
          default:
            return null;
        }
      })}
    </Box>
  );
};

export default UserInformation;
